import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { CarouselAction, CarouselGetter } from '@/store/carousel/carousel.module';
import { Carousel } from '@/store/carousel/carousel.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import Draggable from 'vuedraggable';

export default defineComponent({
  name: 'CarouselListComponent',
  components: {
    LoadingComponent,
    Draggable,
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const store = useStore();
    const carousels = computed<Carousel[]>(() => store.getters[CarouselGetter.ALL]);
    const isLoading = computed(() => store.getters[CarouselGetter.STATUS] === 'init' || store.getters[CarouselGetter.STATUS] === 'loading');

    const dragging = ref(false);
    const dragOptions = {
      animation: 200,
      group: 'description',
    };

    onMounted(() => {
      store.dispatch(CarouselAction.FETCH);
    });

    interface VueDraggableEvent {
      moved: {
        element: unknown;
        oldIndex: number;
        newIndex: number;
      };
    }
    const onMoved = (event: VueDraggableEvent) => {
      const carousel = event.moved.element as Carousel;

      store.dispatch(CarouselAction.REORDER, {
        id: carousel.id,
        sequence: event.moved.newIndex
      });
    };

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    return {
      carousels,
      isLoading,
      dragOptions,
      dragging,
      editClick,
      onMoved,
    };
  },
});
